import { MultiSelect } from "@/components/fields/multi-select";
import { AutoFormFieldProps } from "@autoform/react";
import { useWatch } from "react-hook-form";

interface MoeMappingFieldProps extends AutoFormFieldProps {}

const MoeMappingField = (props: MoeMappingFieldProps) => {
  const { field, inputProps } = props;
  const value = useWatch({ name: field.key });

  return (
    <div className="flex flex-col space-y-2 text-foreground w-full">
      <MultiSelect
        options={[
          { label: "Attica", value: "Attica" },
          { label: "Thessaloniki", value: "Thessaloniki" },
          { label: "București", value: "București" },
          { label: "North Holland", value: "North Holland" },
          { label: "South Holland", value: "South Holland" },
          { label: "Cluj County", value: "Cluj County" },
          {
            label: "Central Macedonia",
            value: "Central Macedonia",
          },
          { label: "Achaea", value: "Achaea" },
          { label: "Ilfov", value: "Ilfov" },
          { label: "Utrecht", value: "Utrecht" },
          { label: "North Brabant", value: "North Brabant" },
          { label: "Prahova", value: "Prahova" },
          { label: "Iași County", value: "Iași County" },
          { label: "Timiș County", value: "Timiș County" },
          { label: "Brașov County", value: "Brașov County" },
          { label: "Gelderland", value: "Gelderland" },
          { label: "Constanța County", value: "Constanța County" },
          {
            label: "Heraklion Regional Unit",
            value: "Heraklion Regional Unit",
          },
          { label: "Nomós Larísis", value: "Nomós Larísis" },
          { label: "Bihor County", value: "Bihor County" },
          { label: "Overijssel", value: "Overijssel" },
          { label: "Limburg", value: "Limburg" },
          { label: "Flevoland", value: "Flevoland" },
          { label: "Nicosia", value: "Nicosia" },
          { label: "Sibiu County", value: "Sibiu County" },
          { label: "Ioannina", value: "Ioannina" },
          { label: "Magnesia", value: "Magnesia" },
          { label: "Dolj", value: "Dolj" },
          { label: "Chania", value: "Chania" },
          { label: "Euboea", value: "Euboea" },
          { label: "Groningen", value: "Groningen" },
          { label: "Arges", value: "Arges" },
          { label: "Dâmbovița County", value: "Dâmbovița County" },
          { label: "Buzău County", value: "Buzău County" },
          { label: "Galați County", value: "Galați County" },
          { label: "Dodecanese", value: "Dodecanese" },
          { label: "Corinthia", value: "Corinthia" },
          { label: "Arad County", value: "Arad County" },
          { label: "Friesland", value: "Friesland" },
          { label: "Nomós Kerkýras", value: "Nomós Kerkýras" },
          { label: "Nomós Kykládon", value: "Nomós Kykládon" },
          { label: "Nomós Voiotías", value: "Nomós Voiotías" },
          { label: "Messenia", value: "Messenia" },
          { label: "Kozani", value: "Kozani" },
          { label: "Bacău County", value: "Bacău County" },
          { label: "Mureș County", value: "Mureș County" },
          { label: "Vâlcea County", value: "Vâlcea County" },
          {
            label: "Limassol District",
            value: "Limassol District",
          },
          { label: "Sérres", value: "Sérres" },
          { label: "Rethymno", value: "Rethymno" },
          { label: "Suceava", value: "Suceava" },
          { label: "Hunedoara County", value: "Hunedoara County" },
          { label: "Kavala", value: "Kavala" },
          {
            label: "North Rhine-Westphalia",
            value: "North Rhine-Westphalia",
          },
          { label: "Pella", value: "Pella" },
          { label: "West Greece", value: "West Greece" },
          { label: "Arcadia", value: "Arcadia" },
          { label: "Xanthi", value: "Xanthi" },
          { label: "Nomós Rodópis", value: "Nomós Rodópis" },
          { label: "Nomós Kardhítsas", value: "Nomós Kardhítsas" },
          { label: "Nomós Kilkís", value: "Nomós Kilkís" },
          { label: "Teleorman County", value: "Teleorman County" },
          { label: "Călărași County", value: "Călărași County" },
          { label: "Crete", value: "Crete" },
          { label: "Gorj County", value: "Gorj County" },
          { label: "Chalkidikí", value: "Chalkidikí" },
          { label: "Laconia", value: "Laconia" },
          { label: "Chios", value: "Chios" },
          { label: "Thessaly", value: "Thessaly" },
          { label: "Brăila County", value: "Brăila County" },
          { label: "Ialomița County", value: "Ialomița County" },
          { label: "Peloponnese", value: "Peloponnese" },
        ]}
        selected={value ?? []}
        onChange={(v) => {
          const syntheticEvent = {
            target: {
              value: v,
              name: field.key,
            },
          } as unknown as React.ChangeEvent<HTMLInputElement>;
          inputProps.onChange(syntheticEvent);
        }}
        placeholder="Select or type MoE regions..."
      />
    </div>
  );
};

export default MoeMappingField;
